import i18n from '@/plugins/i18n';
import { getCookie } from '@/utils/cookie';
import { LOCAL_STORAGE_KEY } from '@/constants';

/**
 * 是否为英文环境
 * 语言环境获取优先级：i18n.global.locale.value -> cookie -> localStorage -> navigator.language
 */
export const isEnLang = () => {
  const language =
    i18n.global.locale.value ||
    getCookie(LOCAL_STORAGE_KEY.LANGUAGE) ||
    localStorage.getItem('lang') ||
    navigator.language;

  return language === 'en-US' || language === 'en' || language?.toLowerCase() === 'english';
};

/**
 * 按当前语言返回动态字段/key 名：英文环境为 `${base}En`，否则为 `base`。
 * @param {string} base - 基础名，如传入 "title" → 英文返回 "titleEn"，非英文返回 "title"
 * @returns {string}
 */
export const getLocalizedKeyName = (base) => {
  if (typeof base !== 'string' || base === '') return base;
  return isEnLang() ? `${base}En` : base;
};

/**
 * 通用的国际化字段获取方法
 * 根据当前语言环境，从对象中获取对应语言的字段值
 *
 * @param {Object} obj - 包含多语言字段的对象
 * @param {string} field - 要获取的字段名
 * @returns {string} 对应语言的字段值，如果不存在则返回默认值
 */
export function getI18nField(obj, field = 'name') {
  if (!obj) return '';
  const langKey = getLocalizedKeyName(field);
  return obj[langKey] || obj[field] || '';
}
